import { render, staticRenderFns } from "./ContaForm.vue?vue&type=template&id=88590b3c&scoped=true"
import script from "./ContaForm.vue?vue&type=script&lang=js"
export * from "./ContaForm.vue?vue&type=script&lang=js"
import style0 from "./ContaForm.vue?vue&type=style&index=0&id=88590b3c&prod&scoped=true&lang=css"
import style1 from "./ContaForm.vue?vue&type=style&index=1&id=88590b3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88590b3c",
  null
  
)

export default component.exports